import styled from "@emotion/styled";
import * as React from "react";

import { StyledExternalLink } from "components/external-link";

const Wrapper = styled.p`
  margin-top: 20px;
  font-size: 12px;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor50
  };
  text-align: center;
`;

const PoweredBy: React.FC = () => (
  <Wrapper>
    Powered by{" "}
    <StyledExternalLink href="https://www.helpdesk.com/powered-by-helpdesk/?utm_source=ticket-rating">
      HelpDesk
    </StyledExternalLink>
  </Wrapper>
);

export default PoweredBy;
